import { MfeReactComponent } from '@carvana/microfrontend-react';
import { useContext, useEffect } from 'react';
import { commonEnvironment } from '~/constants/environment';
import StaticContext from '~/contexts/StaticContext';
import { loadFooterMfe } from '~/utilities/MicroFrontEnds';

export default function Footer() {
  const { removeFooter } = useContext(StaticContext);

  useEffect(() => {
    if (removeFooter) return;

    void loadFooterMfe();
  }, [removeFooter]);

  return removeFooter ? null : (
    <MfeReactComponent
      component="default"
      module="FooterModule"
      environment={commonEnvironment}
      withoutProvider
    />
  );
}
